import { Pill, Stack } from 'component-library';

export const LinkCard = ({
  title,
  thumbnailUrl,
  className,
  pillText,
  href,
}: {
  title: string;
  thumbnailUrl?: string;
  className?: string;
  pillText?: string;
  href: string;
}) => {
  return (
    <a href={href} target='_blank' rel='noopener noreferrer' data-testid='link-card-anchor'>
      <Stack data-testid='link-card' spacing={3} className={className}>
        {thumbnailUrl && <LinkCardThumbnail title={title} thumbnailUrl={thumbnailUrl} />}
        <LinkCardInfo title={title} pillText={pillText} />
      </Stack>
    </a>
  );
};

const LinkCardThumbnail = ({ title, thumbnailUrl }: { title: string; thumbnailUrl: string }) => {
  return (
    <div data-testid='link-card-thumbnail'>
      <img
        src={thumbnailUrl}
        alt={`Thumbnail for ${title}`}
        className='w-full h-48 object-cover rounded-2xl border border-divider'
      />
    </div>
  );
};

const LinkCardInfo = ({ title, pillText }: { title: string; pillText?: string }) => {
  return (
    <Stack data-testid='link-card-info' spacing={2}>
      {pillText && (
        <Pill size='small' className='bg-neutral-black-12 text-neutral-black-80 self-start'>
          {pillText}
        </Pill>
      )}
      <span className='typography-h6 text-text-primary line-clamp-2'>{title}</span>
    </Stack>
  );
};
